<div *ngIf="promptSelectAll$ | async" class="flex bg-slate-100-important mb-2 mt-1 min-h-[60px]">
  <div *ngIf="(selectAll$ | async) === false" class="flex grow justify-center items-center text-slate-500-important" [ngClass]="fontSize">
    All&nbsp;<b>{{ idsSelectedOnPage$ | async }}</b
    >&nbsp;devices on this page are selected.
    <a mat-button (click)="turnOnSelectAll()" color="primary">Select all {{ getTotal() | async }}devices</a>
  </div>
  <div *ngIf="(selectAll$ | async) === true" class="flex grow justify-center items-center text-slate-500-important" [ngClass]="fontSize">
    All&nbsp;<b>{{ getTotal() | async }}</b
    >&nbsp;devices are selected. <a mat-button (click)="turnOffSelectAll()" color="primary">Clear selection</a>
  </div>
  <div *ngIf="(selectAll$ | async) === false" class="flex grow-0 justify-center items-center">
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
